export default {
    401: 'Authorization failed',
    400: 'Parameter error',
    500: 'Service Error',
};